import React, { lazy, Suspense } from 'react'
// import MyProfile from './MyProfile/MyProfile';
import UserProfile from './UserProfile/UserProfile'
import CoupleTabs from './CoupleTabs'

const LazyMyProfile = lazy(() =>
  import(/* webpackPrefetch: true, webpackChunkName: "my-profile" */ './MyProfile/MyProfile')
)

const MyProfile = props => (
  <Suspense fallback={null}>
    <LazyMyProfile {...props} />
  </Suspense>
)

export { MyProfile, UserProfile, CoupleTabs }
